import React, { Component } from 'react';
import classNames from 'classnames';
import ProptTypes from 'prop-types';

import TitleSalaryOnlyStateMapFooter from './titleSalaryOnlyStateMapFooter';
import TitleSalaryOnlyStateMapTemplate from './titleSalaryOnlyStateMapTemplate';

import classes from './index.module.css';

const propTypes = {
  embedWidgetType: ProptTypes.oneOf([
    'best-states-map',
    'salary-heatmap',
    'salary-only-state-heatmap',
    'location-heatmap',
    'demand-heatmap',
    'major-salary-map',
    'career-paths',
    'college-major-paths',
  ]).isRequired,

  onMapLoadError: ProptTypes.func,
  isEmbeddable: ProptTypes.bool,
  isWidget: ProptTypes.bool,
  widgetAddContent: ProptTypes.any,
  embedWidgetUrl: ProptTypes.string,
  targetPageUrl: ProptTypes.string,
  svgFileUrl: ProptTypes.string,
  originalUrl: ProptTypes.string,
  gtmEventName: ProptTypes.objectOf(ProptTypes.any),
  mapTooltip: ProptTypes.objectOf(ProptTypes.any),
  legendTooltip: ProptTypes.objectOf(ProptTypes.any),
  legendLabelsCallback: ProptTypes.func,
};

const defaultProps = {
  onMapLoadError: () => {},
  isEmbeddable: false,
  isWidget: false,
  widgetAddContent: '',
  embedWidgetUrl: '',
  targetPageUrl: '',
  svgFileUrl: '',
  originalUrl: '',
  gtmEventNames: {
    open: '',
  },
  mapTooltip: {
    title: '',
    valueFormatFunc: () => {},
    subTextFormatFunc: () => {},
  },
  legendTooltip: {
    title: '',
    valueFormatFunc: () => {},
  },
  legendLabelsCallback: () => {},
};

class StatesCountyMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      svg: null,
      selectedLabelId: null,
    };
  }

  _onMapLoadSuccess = (svg) => {
    this.setState({
      svg,
    });
  };

  _onLabelLegendSelect = (selectedLabelId) => {
    this.setState({
      selectedLabelId,
    });
  };

  render() {
    const { _onMapLoadSuccess, _onLabelLegendSelect } = this;
    const { svg, selectedLabelId } = this.state;
    const { isWidget } = this.props;

    return (
      <div
        className={classNames(classes['county-state-salary-map-container'], {
          [classes['widget']]: isWidget,
          'z-pb-50': isWidget,
          [`darken ${selectedLabelId}`]: selectedLabelId,
        })}
      >
        <TitleSalaryOnlyStateMapTemplate {...this.props} onMapLoadSuccess={_onMapLoadSuccess} />
        {svg && (
          <TitleSalaryOnlyStateMapFooter
            {...this.props}
            svg={svg}
            onLabelLegendSelect={_onLabelLegendSelect}
          />
        )}
      </div>
    );
  }
}

StatesCountyMap.propTypes = propTypes;
StatesCountyMap.defaultProps = defaultProps;

export default StatesCountyMap;
